// import React, { useCallback} from "react";
// import {loadStripe} from '@stripe/stripe-js';
// import {
//   EmbeddedCheckoutProvider,
//   EmbeddedCheckout
// } from '@stripe/react-stripe-js';
// import {
//   BrowserRouter as Router,
//   Route,
//   Routes,
//   Navigate
// } from "react-router-dom";
// import { useCart } from "../contexts/CartContext";
// import axios from "../../config/axios";
// const stripeToken = process.env.REACT_APP_STRIPE_TOKEN;
// //const stripePromise = loadStripe("pk_test_51SRstxE2bP6JY88OzhUgJrdzmbX7C7RBh79e1zXRzFrYunrNVuRk0JShw2AhovzxvjP923gknqueYkPDviSTVlXO00oyQR9On3");
// //console.log(stripeToken)
// const stripePromise = loadStripe(stripeToken);
// function StripeOrderPayment() {
//   const { cart } = useCart();
//   //console.log(cart)

//   const fetchClientSecret = useCallback( async () => {

//     // const data = await axios.post("/cart/online-payment-checkout-for-order", {
//     //     cartId: cart?.orderCart?._id,
//     // });

//     // console.log("clientSecret =>",data.clientSecret)
//     // return data.clientSecret
//     // Create a Checkout Session
//     return fetch(`${process.env.REACT_APP_BACKEND_URL}web/cart/online-payment-checkout-for-order`, {
//       method: "POST",
//       headers: {
//       'Content-Type': 'application/json',
//       // 'Content-Type': 'application/x-www-form-urlencoded', // for URL-encoded data
//     },
//     body: JSON.stringify({cartId:cart?.orderCart?._id}),
//     })
//       .then((res) => res?.json())
//       .then((data) => data.clientSecret);
//   }, []);

//   const options = {fetchClientSecret};
//   //console.log("options =>",options)

//   return (
//     <div id="checkout">
//       <EmbeddedCheckoutProvider
//         stripe={stripePromise}
//         options={options}
//       >
//         <EmbeddedCheckout />
//       </EmbeddedCheckoutProvider>
//     </div>
//   )
// }

// export default StripeOrderPayment
import React, { useCallback, useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { useCart } from "../contexts/CartContext";
import Modal from "../common/Modal"; // Your modal component
import { useNavigate } from "react-router-dom";
import FullScreenLoading from "../common/loading/FullScreenLoading";

const stripeToken = process.env.REACT_APP_STRIPE_TOKEN;
const stripePromise = loadStripe(stripeToken);

export default function StripeOrderPayment() {
  const { cart } = useCart();
  const [clientSecret, setClientSecret] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const fetchClientSecret = useCallback(async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}web/cart/online-payment-checkout-for-order`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ cartId: cart?.orderCart?._id }),
        }
      );
      if (!res.ok)
        throw new Error(`Payment initiation failed. Please try again.`);

      const data = await res.json();

      if (!data?.clientSecret || typeof data.clientSecret !== "string") {
        throw new Error("Payment initiation failed. Please try again.");
      }

      setClientSecret(data.clientSecret);
      setError(null); // Clear previous error
      return data.clientSecret;
    } catch (err) {
      console.error("Error fetching clientSecret:", err);
      setClientSecret(null);
      setError("Payment initiation failed. Please try again.");
      return null; // Stripe won't initialize if null
    }
  }, [cart?.orderCart?._id]);

  // Initial fetch
  useEffect(() => {
    fetchClientSecret();
  }, [fetchClientSecret]);

  return (
    <div id="checkout">
      {error && (
        <Modal
          isOpen={!!error}
          onClose={() => navigate(-1)}
          title={"Payment Error"}
          onConfirm={() => navigate(-1)}
          confirmButton="Retry Payment"
          dismissible={false}
          showCancel={false}
        >
          <div className="font-mono">
            <p>{error}</p>
          </div>
        </Modal>
      )}

      {/* Render Stripe only if clientSecret is available */}
      {clientSecret && (
        <EmbeddedCheckoutProvider
          stripe={stripePromise}
          options={{ fetchClientSecret: () => clientSecret }}
        >
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      )}

      {!clientSecret && !error && <FullScreenLoading />}
    </div>
  );
}
